export enum B2CDiscountUnit {
  PERCENTAGE = 'Percentage',
  AMOUNT = 'Amount',
}
